import { createFileRoute, redirect } from '@tanstack/react-router';

/** Forward bookmarks from the former client database location. */
export const Route = createFileRoute('/console/$orgId/configuration/client-database/$')({
    beforeLoad: ({ params }): never => {
        throw redirect({ to: '/console/$orgId/configuration/fleet/client-database', params, replace: true });
    },
});
